import { HStack, Icon, Text } from '@chakra-ui/react'
import { faCheck, faClock } from '@fortawesome/pro-light-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'

import { PolicyVersionStatus } from '@/dtos/exceptionalDiscount'

const statusVisuals: Record<PolicyVersionStatus, { label: string, bg: string, color: string, icon?: typeof faClock }> = {
  [PolicyVersionStatus.active]: { label: 'Aktivní', bg: 'green.100', color: 'green.700' },
  [PolicyVersionStatus.indexed]: { label: 'Čeká', bg: 'primary.50', color: 'primary.700', icon: faClock },
  [PolicyVersionStatus.pending]: { label: 'Čeká', bg: 'primary.50', color: 'primary.700', icon: faClock },
  [PolicyVersionStatus.terminated]: { label: 'Ukončeno', bg: 'gray.200', color: 'gray.600', icon: faCheck },
  [PolicyVersionStatus.error]: { label: 'Chyba', bg: 'red.100', color: 'red.700' },
}

export const statusRailColor: Record<PolicyVersionStatus, string> = {
  [PolicyVersionStatus.active]: 'green.400',
  [PolicyVersionStatus.indexed]: 'primary.500',
  [PolicyVersionStatus.pending]: 'primary.500',
  [PolicyVersionStatus.terminated]: 'gray.400',
  [PolicyVersionStatus.error]: 'red.500',
}

export const StatusChip = ({ status }: { status: PolicyVersionStatus }) => {
  const visual = statusVisuals[status]

  return (
    <HStack
      spacing={1.5}
      px={2}
      py={0.5}
      bg={visual.bg}
      color={visual.color}
      borderRadius="sm"
      textTransform="uppercase"
      letterSpacing="0.05em"
    >
      {visual.icon && <Icon as={FontAwesomeIcon} icon={visual.icon} boxSize={3} />}
      <Text fontSize="xs" fontWeight="bold" color="inherit">{visual.label}</Text>
    </HStack>
  )
}
